import { render, staticRenderFns } from "./VlPoi.vue?vue&type=template&id=460d2031&scoped=true&"
import script from "./VlPoi.vue?vue&type=script&lang=js&"
export * from "./VlPoi.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "460d2031",
  null
  
)

export default component.exports